import React from "react";
import { Modal, Card, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Pricing({ isOpen, setOpen }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCancel = () => setOpen(false);
  const goToSub = (planId) => {
    setOpen(false);
    navigate(`/book?plan=${encodeURIComponent(planId)}`);
  };

  return (
    <Modal
      name="pricing"
      title="Pricing"
      centered
      open={isOpen}
      footer={null}
      onCancel={handleCancel}
      width={1200}
      style={{ maxWidth: "90%" }}
    >
      <div className="w-full flex flex-wrap justify-center mt-[16px] gap-8">

        {/* Essential Access */}
        <Card
          title={<span className="font-semibold">Essential Access</span>}
          className="card"
          style={{ width: 315, boxShadow: "0 0 0 5px #56277c", backgroundColor: "#f3f3f3ff" }}
        >
          <ul className="px-[22px]">
            <li className="mb-[15px]" style={{ listStyleType: "none" }}>
              <span className="font-bold text-[24px]">$50</span> /employee <br />
              <span className="font-bold" style={{ color: "blue" }}>Individual Access Plan</span>
            </li>
            <li><span className="font-bold">Full access to all CiviBOT features</span></li>
            <li><span className="font-bold">30-day free trial</span></li>
          </ul>
          <br /> 
          <br />
          <Button type="primary" className="w-full mt-[20px]" onClick={() => goToSub("essential")}>
            {t("book.subscribe")}
          </Button>
        </Card>

        {/* Growth Access */}
        <Card
          title={<span className="font-semibold">Growth Access</span>}
          className="card"
          style={{ width: 315, boxShadow: "0 0 0 5px #338cb8", backgroundColor: "#f3f3f3ff" }}
        >
          <ul className="px-[22px]">
            <li className="mb-[15px]" style={{ listStyleType: "none" }}>
              <span className="font-bold text-[24px]">$30</span> /employee <br />
              <span className="font-bold" style={{ color: "blue" }}>11-50 employees</span>
            </li>
            <li><span className="font-bold">Full access to all CiviBOT features</span></li>
            <li><span className="font-bold">30-day free trial</span></li>
            <li><span className="font-bold">Onboarding and Training</span></li>
          </ul>
          <br />
          <Button type="primary" className="w-full mt-[20px]" onClick={() => goToSub("growth")}>
            {t("book.subscribe")}
          </Button>
        </Card>

        {/* Enterprise Suite */}
        <Card
          title={<span className="font-semibold">Enterprise Suite</span>}
          className="card"
          style={{ width: 315, boxShadow: "0 0 0 5px #1dcbda", backgroundColor: "#f3f3f3ff" }}
        >
          <ul className="px-[22px]">
            <li className="mb-[15px]" style={{ listStyleType: "none" }}>
              <span className="font-bold text-[24px]">$20</span> /employee <br />
              <span className="font-bold" style={{ color: "blue" }}>51+ employees</span>
            </li>
            <li><span className="font-bold">Full access to all CiviBOT features</span></li>
            <li><span className="font-bold">30-day free trial</span></li>
            <li><span className="font-bold">Onboarding and Training</span></li>
            <li><span className="font-bold">Custom Features</span></li>
          </ul>
          <Button type="primary" className="w-full mt-[20px]" onClick={() => goToSub("enterprise")}>
            {t("book.subscribe")}
          </Button>
        </Card>

      </div>
    </Modal>
  );
}
